import { MapTo } from '@adobe/aem-react-editable-components';
import { withTranslation } from '@yme/services/i18n';
import { AEM_FUNCTIONS } from '../../../../common';
import { Specifications } from './Specifications';
import { isSpecificationsEmpty } from './helpers';
const specificationsEditConfig = {
    emptyLabel: 'Specifications',
    isEmpty: isSpecificationsEmpty,
};
export default MapTo(AEM_FUNCTIONS.specifications)(withTranslation(Specifications), specificationsEditConfig);
